import { Pipe, PipeTransform } from '@angular/core';
import {FormControl} from '@angular/forms';

@Pipe({
  name: 'filterCertificates',
  pure: false
})
export class FilterCertificatesPipe implements PipeTransform {
  transform(items: any[], filter: FormControl): any {
    if (!items || !filter?.value) {
      return items;
    }
    return items.filter(item => item.certificateNumber.indexOf(filter.value) !== -1);
  }
}
